import { devLogError } from "./sentryCaptureException";

export default async function eCRMCustomEvent(customEventName, customEventData) {
  try {
    if (window.eCRM) {
      window.eCRM("track", {
        eventName: customEventName,
        eventData: customEventData,
      });
    }
  } catch (error) {
    devLogError(error);
  }
}

export async function eCRMEvent(eventName, eventData) {
  try {
    if (window.eCRM) {
      if (eventData) {
        window.eCRM(eventName, eventData);
      } else {
        window.eCRM(eventName);
      }
    }
  } catch (error) {
    devLogError(error);
  }
}